/* ===============================
   GLOBAL UPSELL HANDLER
   =============================== */

const UPGRADE_STORAGE_KEY = 'cart_upgrade_success';

/* --------------------------------
   Refresh Cart Drawer
--------------------------------- */
function refreshCartDrawerAfterAdd() {
  fetch('/?sections=cart-drawer')
    .then(res => res.json())
    .then(sections => {
      const htmlString = sections['cart-drawer'];
      if (!htmlString) return;

      const parsed = new DOMParser().parseFromString(htmlString, 'text/html');
      const newDrawer = parsed.querySelector('cart-drawer');
      const currentDrawer = document.querySelector('cart-drawer');

      if (!newDrawer || !currentDrawer) return;

      currentDrawer.replaceWith(newDrawer);

      newDrawer.classList.add('active', 'animate');
      document.body.classList.add('overflow-hidden');

      /* 🔥 Re-apply upgrade message AFTER DOM replacement */
      restoreUpgradeSuccessMessage();
    })
    .catch(err => {
      console.error('[UPSSELL] Drawer refresh failed:', err);
    });
}

/* --------------------------------
   Save + Restore Success Message
--------------------------------- */
function saveUpgradeSuccessMessage(variantTitle, planName) {
  sessionStorage.setItem(
    UPGRADE_STORAGE_KEY,
    JSON.stringify({
      variantTitle,
      planName
    })
  );
}

function restoreUpgradeSuccessMessage() {
  const data = sessionStorage.getItem(UPGRADE_STORAGE_KEY);
  if (!data) return;

  try {
    const { variantTitle, planName } = JSON.parse(data);
    updateUpgradeSuccessMessage(variantTitle, planName);
  } catch (e) {
    console.warn('[UPSSELL] Failed to restore message');
  }
}

/* --------------------------------
   Upgrade Success Message (PERSISTENT)
--------------------------------- */
function updateUpgradeSuccessMessage(variantTitle, planName) {
  const wrapper = document.querySelector('.cart_upgrade_success');
  if (!wrapper) return;

  const variantEl = wrapper.querySelector('.upgraded_item_variant');
  const planEl = wrapper.querySelector('.upgraded_item_plan');

  // Clear existing content first
  if (variantEl) variantEl.textContent = '';
  if (planEl) planEl.textContent = '';

  // Inject values
  if (variantEl && variantTitle) {
    variantEl.textContent = variantTitle;
  }

  if (planEl && planName) {
    planEl.textContent = ` (${planName})`;
  }

  // ✅ Only show AFTER values are set
  if (variantTitle || planName) {
    wrapper.classList.add('active');
  }
}

/* --------------------------------
   GLOBAL CLICK HANDLER
--------------------------------- */
document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.upsell-btn');
  if (!btn) return;

  const variantId = Number(btn.dataset.upsellVariantId);
  const productId = Number(btn.dataset.upsellProductId);
  const variantTitle = btn.dataset.upsellVariantTitle || '';
  const sellingPlanId = btn.dataset.upsellSellingPlanId
    ? Number(btn.dataset.upsellSellingPlanId)
    : null;
  const sellingPlanName = btn.dataset.upsellSellingPlanName || '';

  if (!variantId || !productId) return;

  e.preventDefault();
  btn.disabled = true;

  try {
    /* 1️⃣ Fetch current cart */
    const cart = await fetch('/cart.js').then(r => r.json());

    /* 2️⃣ Remove MAIN product (same PRODUCT, any variant, paid only) */
    const itemToReplace = cart.items.find(item =>
      item.product_id === productId && item.final_price > 0
    );

    if (itemToReplace) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: itemToReplace.key,
          quantity: 0
        })
      });
    }

    /* 3️⃣ Build add-to-cart payload */
    const payload = {
      id: variantId,
      quantity: 1
    };

    if (sellingPlanId) {
      payload.selling_plan = sellingPlanId;
    }

    /* 4️⃣ Add upsell product */
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    /* 5️⃣ Persist success message */
    saveUpgradeSuccessMessage(variantTitle, sellingPlanName);

    /* 6️⃣ Refresh cart drawer */
    refreshCartDrawerAfterAdd();

  } catch (err) {
    console.error('[UPSSELL ERROR]', err);
  }

  btn.disabled = false;
});



// /* ===============================
//    GLOBAL UPSELL HANDLER
//    =============================== */

// document.addEventListener('click', async function (e) {
//   const btn = e.target.closest('.upsell-btn');
//   if (!btn) return;

//   const variantId = Number(btn.dataset.upsellVariantId);
//   const productId = Number(btn.dataset.upsellProductId);
//   const sellingPlanId = btn.dataset.upsellSellingPlanId
//     ? Number(btn.dataset.upsellSellingPlanId)
//     : null;

//   if (!variantId || !productId) return;

//   e.preventDefault();
//   btn.disabled = true;

//   try {
//     /* 1️⃣ Get cart */
//     const cart = await fetch('/cart.js').then(r => r.json());

//     /* 2️⃣ Remove SAME PRODUCT (any variant, paid item) */
//     const itemToReplace = cart.items.find(item =>
//       item.product_id === productId && item.final_price > 0
//     );

//     if (itemToReplace) {
//       await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           id: itemToReplace.key,
//           quantity: 0
//         })
//       });
//     }

//     /* 3️⃣ Build payload */
//     const payload = {
//       id: variantId,
//       quantity: 1
//     };

//     if (sellingPlanId) {
//       payload.selling_plan = sellingPlanId;
//     }

//     /* 4️⃣ Add upsell product */
//     await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(payload)
//     });

//     /* 5️⃣ Refresh cart drawer */
//     if (typeof refreshCartDrawerAfterAdd === 'function') {
//       refreshCartDrawerAfterAdd();
//     }

//   } catch (err) {
//     console.error('[UPSSELL ERROR]', err);
//   }

//   btn.disabled = false;
// });


